import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toggleNotificationList } from './Actions';
/**
 * Count the number of unread notifications in the array.
 *
 * @param {Array} notifications
 *   Notifications.
 *
 * @returns {number}
 *   The count.
 */
const countUnreadNotifications = (notifications = []) => {
    let count = 0;
    notifications.forEach((notification) => {
        // If the notification is unread, or it has an unresolved action.
        if (!notification.is_read || (notification.action_key && notification.action_done == null)) {
            count += 1;
        }
    });
    return count;
};
const ComponentTitle = ({ notifications = [], dispatch }) => {
    const unread = countUnreadNotifications(notifications);
    return (_jsx("div", Object.assign({ className: "toolbar-notifications" }, { children: _jsx("button", Object.assign({ onClick: () => { dispatch(toggleNotificationList()); } }, { children: _jsx("i", Object.assign({ className: `toolbar-icon ${unread > 0 ? 'toolbar-icon__active' : ''} fas fa-globe-europe` }, { children: unread > 0 && _jsx("span", Object.assign({ className: unread > 9 ? 'double-digits' : '' }, { children: unread })) })) })) })));
};
ComponentTitle.propTypes = {
    notifications: PropTypes.array,
    dispatch: PropTypes.func
};
const mapStateToProps = (state) => ({ notifications: state.notifications.items });
export default connect(mapStateToProps)(ComponentTitle);
